import React, { Component, useState, useRef, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import VendorHeader from "./../component/VendorHeader";
import VendorFooter from "./../component/VendorFooter";
import countryGroups from "../assets/country-groups.json";
import $ from "jquery";
import { API_BASE_URL, IMAGE_URL } from "../utils/app_url";
import { useLanguage } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import Sidebar from "../component/Sidebar";
import { NotificationManager } from "react-notifications";
import AiEnhancePanel from "../component/AiEnhancePanel";

const icon1 = require("./../assets/img/dashboard-icon.svg").default;
const icon2 = require("./../assets/img/info-icon.svg").default;
const icon3 = require("./../assets/img/app-icon.svg").default;
const icon4 = require("./../assets/img/payment-icon.svg").default;
const icon5 = require("./../assets/img/store-icon.svg").default;
const icon6 = require("./../assets/img/list-icon.svg").default;
const icon7 = require("./../assets/img/order-icon.svg").default;
const icon8 = require("./../assets/img/plan-icon.svg").default;
const icon9 = require("./../assets/img/logout-icon.svg").default;
const deleteIcon = require("./../assets/img/delete-icon.svg").default;

const DuplicateProduct = () => {
  const { user, storeData, setStoreData } = useAuth();
  const navigate = useNavigate();
  const { selectedLanguage, langJson } = useLanguage();
  const { id } = useParams();
  const imageBtnRef = useRef();

  const [addFormData, setAddFormData] = useState({
    article_no: null,
    order_no: null,
    article_name: null,
    brand: null,
    color: null,
    article_description: null,
    unit_price: null,
    currency: "₹",
    price: null,
    article_type: null,
    size: null,
    original_price: null,
    main_category: null,
    sub_category: null,
    show_category: null,
    made_in: "",
    stock_type: "in_stock",
    estimated_delivery_date: "",
    estimated_delivery_days: "",
    ships_from: "",
    eligible_for: "",
    details: "",
  });

  const [dropdownLang, setDropdownLang] = useState(selectedLanguage || "en");
  useEffect(() => {
    setDropdownLang(selectedLanguage || "en");
  }, [selectedLanguage]);

  const renderMadeInDropdown = () => {
    return (
      <select
        name="made_in"
        value={addFormData.made_in}
        onChange={handleChange}
        style={{ width: "100%", padding: "8px", marginBottom: "16px" }}
      >
        <option value="">{langJson?.madein || "Made In"}</option>
        {countryGroups.map(group => (
          group.countries.length > 1 ? (
            <optgroup key={group.group} label={group.group}>
              {group.countries.map(country => (
                <option key={country.code} value={country.code}>
                  {country.names[dropdownLang] || country.names["en"]}
                </option>
              ))}
            </optgroup>
          ) : (
            group.countries.map(country => (
              <option key={country.code} value={country.code}>
                {country.names[dropdownLang] || country.names["en"]}
              </option>
            ))
          )
        ))}
      </select>
    );
  };

  const renderShipsFromDropdown = () => (
    <select
      name="ships_from"
      value={addFormData.ships_from}
      onChange={handleChange}
      style={{ width: "100%", padding: "8px", marginBottom: "16px" }}
    >
      <option value="">{langJson?.shipsfrom || "Ships From"}</option>
      {countryGroups.map(group => (
        group.countries.length > 1 ? (
          <optgroup key={group.group} label={group.group}>
            {group.countries.map(country => (
              <option key={country.code} value={country.code}>
                {country.names[dropdownLang] || country.names["en"]}
              </option>
            ))}
          </optgroup>
        ) : (
          group.countries.map(country => (
            <option key={country.code} value={country.code}>
              {country.names[dropdownLang] || country.names["en"]}
            </option>
          ))
        )
      ))}
    </select>
  );

  const [sizeArray, setSizeArray] = useState([]);
  const [signupStatus, setSignupStatus] = useState("");
  const [uploadFrontImage, setUploadFrontImage] = useState();
  const [uploadBackImage, setUploadBackImage] = useState();
  const [sizeError, setSizeError] = useState();
  const [imageError, setImageError] = useState();
  const [loading, setLoading] = useState();
  const [addBtnDis, setAddBtnDis] = useState();
  const [categoryList, setCategoryList] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [showCategoryList, setShowCategoryList] = useState([]);
  const [existingImages, setExistingImages] = useState([]);
  const [newImages, setNewImages] = useState([]);
  const [existingVideos, setExistingVideos] = useState([]);
  const [videos, setVideos] = useState([]);
  const videoBtnRef = useRef();
  const currency = ["₹"];
  const allowedVideoExtensions = ["mp4", "webm", "mov", "avi", "mkv"];
  const [videoError, setVideoError] = useState("");

  const handleChange = (event) => {
    const { name, value } = event.target;

    setAddFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const addSize = () => {
    if (!addFormData.size) {
      setSizeError(langJson?.sizeisrequired);
    } else {
      let tempArray = [...sizeArray];
      let index = tempArray.findIndex((item) => item?.size === addFormData.size);
      if (index === -1) {
        if (addFormData.size) {
          tempArray.push({ size: addFormData.size, quantity: 1 });
        } else {
          setSignupStatus(langJson?.pleaseentersize);
        }
        setSizeArray(tempArray);
        setAddFormData((prev) => ({ ...prev, size: "" }));
      } else {
      }
    }
  };

  const removeSize = (index) => {
    let tempArray = [...sizeArray];
    tempArray.splice(index, 1);
    setSizeArray(tempArray);
  };

  const onQuantityChange = (event, index) => {
    let array = [...sizeArray];
    if (event) {
      array[index].quantity = event.target.value;
    } else {
      array[index].quantity = 0;
    }
    setSizeArray(array);
  };

  const handleVideoFiles = (files) => {
    Array.from(files).forEach((file) => {
      const ext = file.name.split(".").pop().toLowerCase();
      const maxSize = 50 * 1024 * 1024;
      if (!allowedVideoExtensions.includes(ext)) {
        setVideoError(langJson?.invalid_file_format_Please_upload_a_valid__image_file || "Invalid video format. Allowed: MP4, WebM, MOV, AVI, MKV");
      } else if (file.size > maxSize) {
        setVideoError("Video size must be less than 50MB");
      } else {
        setVideos((prev) => [...prev, file]);
        setVideoError("");
      }
    });
  };

  const handleVideoDrop = (e) => { e.preventDefault(); if (e.dataTransfer.files.length > 0) handleVideoFiles(e.dataTransfer.files); };
  const handleVideoInput = (e) => { if (e.target.files.length > 0) handleVideoFiles(e.target.files); };
  const handleRemoveVideo = (i) => setVideos((prev) => prev.filter((_, idx) => idx !== i));
  const handleRemoveExistingVideo = (i) => setExistingVideos((prev) => prev.filter((_, idx) => idx !== i));

  const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";
    return date.toISOString().split("T")[0];
  };

  const fetchProductDetails = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}products/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.authorisation.token}`,
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
        setAddFormData({
          article_no: responseData.data.article_no,
          order_no: responseData.data.order_no,
          article_name: responseData.data.title,
          brand: responseData.data.brand,
          color: responseData.data.color,
          article_description: responseData.data.description,
          unit_price: responseData.data.unit_price,
          currency: responseData.data.currency ? responseData.data.currency : "₹",
          price: responseData.data.sale_price,
          original_price: responseData.data.price,
          main_category: responseData.data.season,
          // main_category: responseData.data.CatalogBrand,
          sub_category: responseData.data.pro_cat_id,
          show_category: responseData.data.cat_id,
          article_type: responseData.data.is_public == 1 ? "public" : "hidden",
          made_in: responseData.data.made_in || "",
          stock_type: responseData.data.stock_type || "in_stock",
          estimated_delivery_date: formatDateForInput(responseData.data.estimated_delivery_date),
          estimated_delivery_days: responseData.data.estimated_delivery_days || "",
          ships_from: responseData.data.ships_from || "",
          eligible_for: responseData.data.eligible_for || "",
          details: responseData.data.details || "",
        });
        let tempArray = [];
        responseData.data.stocks.map((item, index) => {
          tempArray.push({ size: item.size, quantity: parseInt(item.stock) });
        });
        setSizeArray(tempArray);
        setExistingImages(responseData?.data?.images || []);
        setExistingVideos(responseData?.data?.videos || []);

        // const fetchImage = async (item) => {
        //   try {
        //     const imageResponse = await fetch(IMAGE_URL + item.image);
        //     const blob = await imageResponse.blob();
        //     setImagesPath((prev) => [...prev, item]);
        //     return blob;
        //   } catch (error) {
        //     console.error("Error fetching image:", error);
        //     // You might want to handle the error here
        //     return null;
        //   }
        // };

        // const fetchImageArray = async () => {
        //   const imagePromises = responseData.data.images.map(fetchImage);

        //   try {
        //     const images = await Promise.all(imagePromises);
        //     // Filter out any null values (errors during fetching)
        //     const filteredImages = images.filter((image) => image !== null);
        //     setImages(filteredImages);
        //   } catch (error) {
        //     console.error("Error fetching images:", error);
        //   }
        // };
        // fetchImageArray();

        // if (responseData.data.CatalogFrontImage) {
        //   try {
        //     const response = await fetch(responseData.data.CatalogFrontImage);
        //     const blob = await response.blob();
        //     setUploadFrontImage(blob);
        //   } catch (error) {
        //     console.error("Error fetching image:", error);
        //   }
        //   // setUploadFrontImage({
        //   //   uri: responseData.data.CatalogFrontImage,
        //   // });
        // }
        // if (responseData.data.CatalogBackImage) {
        //   try {
        //     const response = await fetch(responseData.data.CatalogBackImage);
        //     const blob = await response.blob();
        //     setUploadBackImage(blob);
        //   } catch (error) {
        //     console.error("Error fetching image:", error);
        //   }
        //   // setUploadBackImage({
        //   //   uri: responseData.data.CatalogBackImage,
        //   // });
        // }
      } else {
      }
    } catch (error) {
      console.error("Error during Sign UP:", error);
    }
  };

  const fetchCategory = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}users/search-main-category`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.authorisation.token}`,
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
        let tempArray = responseData?.data.filter(
          (item, index) => item.CatalogSession !== "null" && item.CatalogSession !== "" && item.CatalogSession !== null
        );
        setCategoryList(tempArray);
      } else {
      }
    } catch (error) {
      console.error("Error during Sign UP:", error);
    }
  };

  const fetchSubCategory = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}products/product-categories`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.authorisation.token}`,
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
        setSubCategoryList(responseData.data);
      } else {
      }
    } catch (error) {
      console.error("Error during Sign UP:", error);
      setLoading(false);
    }
  };

  const fetchShowSubCategory = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}products/categories`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.authorisation.token}`,
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
        // let categoryArray = {};
        // responseData.data.forEach((element, key) => {
        //   let category = element?.SubcategoryName?.split("/")[0];
        //   if (!categoryArray[category]) {
        //     categoryArray[category] = [];
        //   }
        //   categoryArray[category].push(element);
        // });
        // let newArray = [];
        // Object.entries(categoryArray).map((item, index) => {
        //   newArray.push({cat: item[0], items: item[1]});
        // });
        setShowCategoryList(responseData.data);
      } else {
      }
    } catch (error) {
      console.error("Error during Sign UP:", error);
      setLoading(false);
    }
  };

  const fetchStoreData = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}stores/dashboard`, {
        method: "GET",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${user.authorisation.token}` },
      });
      const data = await res.json();
      if (data.res === true) {
        setStoreData({
          total_products: data.data?.total_products,
          active_plan: data.data?.store?.active_plan,
        });
      }
    } catch (e) { console.error(e); }
  };

  const handleFrontImageDrop = (event) => {
    event.preventDefault();
    const droppedFiles = event.dataTransfer.files;

    if (droppedFiles.length > 0) {
      const allowedExtensions = ["jpg", "jpeg", "png", "webp", "avif"];

      Array.from(droppedFiles).forEach((file) => {
        const fileExtension = file.name.split(".").pop().toLowerCase();
        if (allowedExtensions.includes(fileExtension)) {
          setNewImages((prev) => [...prev, file]);
        } else {
          setImageError(langJson?.invalid_file_format_Please_upload_a_valid__image_file);
        }
      });
    }
  };

  // const handleFrontImageDrop = event => {
  //   event.preventDefault();
  //   const droppedFiles = event.dataTransfer.files;

  //   if (droppedFiles.length > 0) {
  //     const allowedExtensions = ["jpg", "jpeg", "png"];

  //     Array.from(droppedFiles).forEach(file => {
  //       const fileExtension = file.name.split(".").pop().toLowerCase();
  //       if (allowedExtensions.includes(fileExtension)) {
  //         setImages(prev => [...prev, file]);
  //       } else {
  //         setImageError(langJson?.invalid_file_format_Please_upload_a_valid__image_file);
  //       }
  //     });
  //   }
  // };

  const handleBackImageDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0]; // Get the first file

    if (file) {
      const allowedExtensions = ["jpg", "jpeg", "png", "webp", "avif"];
      if (file) {
        const fileExtension = file.name.split(".").pop().toLowerCase();
        if (allowedExtensions.includes(fileExtension)) {
          setUploadBackImage(file);
          setSignupStatus("");
        } else {
          setUploadBackImage(null);
          setSignupStatus(langJson?.invalid_file_format_Please_upload_a_valid__image_file);
        }
      }
    } else {
    }
  };

  const onImageFrontUploadChange = (e) => {
    const allowedExtensions = ["jpg", "jpeg", "png", "webp", "avif"];
    const file = e.target.files[0];
    if (file) {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (allowedExtensions.includes(fileExtension)) {
        setUploadFrontImage(file);
        setSignupStatus("");
      } else {
        setUploadFrontImage(null);
        setSignupStatus(langJson?.invalid_file_format_Please_upload_a_valid__image_file);
      }
    }
  };

  const onImageBackUploadChange = (e) => {
    const allowedExtensions = ["jpg", "jpeg", "png", "webp", "avif"];
    const file = e.target.files[0];
    if (file) {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (allowedExtensions.includes(fileExtension)) {
        setUploadBackImage(file);
        setSignupStatus("");
      } else {
        setUploadBackImage(null);
        setSignupStatus(langJson?.invalid_file_format_Please_upload_a_valid__image_file);
      }
    }
  };

  const onImageMutipleUpload = (e) => {
    const allowedExtensions = ["jpg", "jpeg", "png", "webp", "avif"];
    const files = e.target.files;

    if (files.length > 0) {
      Array.from(files).forEach((file) => {
        const fileExtension = file.name.split(".").pop().toLowerCase();
        if (allowedExtensions.includes(fileExtension)) {
          setNewImages((prev) => [...prev, file]);
        } else {
          setImageError(langJson?.invalid_file_format_Please_upload_a_valid__image_file);
        }
      });
    }
  };

  const handleRemoveImage = (index) => {
    let tempNewArray = [...newImages];
    let newArray = tempNewArray.filter((item, i) => index !== i);
    setNewImages(newArray);
  };

  const handleReplaceNewImage = (i, file) =>
    setNewImages(prev => prev.map((img, idx) => (idx === i ? file : img)));

  const handleRemoveImageFromServer = async (index) => {
    let tempArray = [...existingImages];
    let updatedArray = tempArray.filter((item, i) => index !== i);
    setExistingImages(updatedArray);
  };

  const onDuplicateArticle = async () => {
    if (storeData?.active_plan === 1 && storeData?.total_products >= 30) {
      NotificationManager.warning(langJson?.plan_limit_products || "Free plan limited to 30 products. Upgrade to Pro to add more.");
      return;
    }
    if (addFormData.article_no === null || addFormData.article_no === undefined || addFormData.article_no === "") {
      setSignupStatus(langJson?.articlenoisrequired);
    } else if (addFormData.order_no === null || addFormData.order_no === undefined || addFormData.order_no === "") {
      setSignupStatus(langJson?.ordernoisrequired);
    } else if (addFormData.article_name === null || addFormData.article_name === undefined || addFormData.article_name === "") {
      setSignupStatus(langJson?.productnameisrequired);
      // } else if (
      //   addFormData.category === null ||
      //   addFormData.category === undefined ||
      //   addFormData.category === ''
      // ) {
      //   setSignupStatus('Category is required.');
    } else if (addFormData.brand === null || addFormData.brand === undefined || addFormData.brand === "") {
      setSignupStatus(langJson?.brandisrequired);
    } else if (addFormData.color === null || addFormData.color === undefined || addFormData.color === "") {
      setSignupStatus(langJson?.colorisrequired);
    } else if (addFormData.currency === null || addFormData.currency === undefined || addFormData.currency === "") {
      setSignupStatus(langJson?.currencyisrequired);
    } else if (addFormData.article_description === null || addFormData.article_description === undefined || addFormData.article_description === "") {
      setSignupStatus(langJson?.articledescriptionisrequired);
    } else if (addFormData.unit_price === null || addFormData.unit_price === undefined || addFormData.unit_price === "") {
      setSignupStatus(langJson?.unitpriceisrequired);
    } else if (!/^[0-9,.]+$/.test(addFormData.unit_price)) {
      setSignupStatus(langJson?.unitpriceacceptsonlynumbers);
    } else if (sizeArray?.length == 0) {
      setSignupStatus(langJson?.sizeisrequired);
    } else if (addFormData.price === null || addFormData.price === undefined || addFormData.price === "") {
      setSignupStatus(langJson?.priceisrequired);
    } else if (!/^[0-9,.]+$/.test(addFormData.price)) {
      setSignupStatus(langJson?.priceacceptsonlynumbers);
    } else if (addFormData.original_price === null || addFormData.original_price === undefined || addFormData.original_price === "") {
      setSignupStatus(langJson?.originalpriceisrequired);
    } else if (!/^[0-9,.]+$/.test(addFormData.original_price)) {
      setSignupStatus(langJson?.originalpriceacceptsonlynumbers);
    } else if (addFormData.main_category === null || addFormData.main_category === undefined || addFormData.main_category === "") {
      setSignupStatus(langJson?.maincategoryisrequired);
    } else if (addFormData.sub_category === null || addFormData.sub_category === undefined || addFormData.sub_category === "") {
      setSignupStatus(langJson?.subcategoryisrequired);
    } else if (addFormData.show_category === null || addFormData.show_category === undefined || addFormData.show_category === "") {
      setSignupStatus(langJson?.showcategoryisrequired);
    } else if (existingImages.length === 0 && newImages.length === 0) {
      setSignupStatus(langJson?.pleaseselectaphoto);
    } else {
      setSignupStatus("");
      setAddBtnDis(true);
      const fd = new FormData();

      // fd.append("front_image", uploadFrontImage);
      // fd.append("back_image", uploadBackImage);

      for (let i = 0; i < existingImages.length; i++) {
        const item = existingImages[i];
        try {
          const imageResponse = await fetch(IMAGE_URL + item.image);
          const blob = await imageResponse.blob();
          const fileName = item?.image ? item.image.split("/").pop() : `image-${i}.jpg`;
          const imageFile = new File([blob], fileName, { type: blob.type || "image/jpeg" });
          fd.append("images[]", imageFile);
        } catch (error) {
          console.error("Error fetching image for duplication:", error);
        }
      }

      newImages.map((item) => {
        fd.append("images[]", item);
      });

      existingVideos.forEach((item) => {
        fd.append("existing_videos[]", item.id);
      });

      videos.forEach((item) => fd.append("videos[]", item));

      // fd.append("company_id", user?.UserId);
      fd.append("article_no", addFormData.article_no);
      fd.append("order_no", addFormData.order_no);
      fd.append("title", addFormData.article_name);
      fd.append("brand", addFormData.brand);
      fd.append("color", addFormData.color);
      fd.append("description", addFormData.article_description);
      fd.append("unit_price", addFormData.unit_price);
      fd.append("currency", addFormData.currency ? addFormData.currency : "₹");
      fd.append("sale_price", addFormData.price);
      fd.append("price", addFormData.original_price);
      fd.append("season", addFormData.main_category);
      fd.append("pro_cat_id", addFormData.sub_category);
      fd.append("cat_id", addFormData.show_category);
      fd.append("is_public", addFormData.article_type === "public" ? 1 : 0);
      fd.append("stocks", JSON.stringify(sizeArray));
      fd.append("made_in", addFormData.made_in || "");
      fd.append("stock_type", addFormData.stock_type || "in_stock");
      fd.append("estimated_delivery_date", addFormData.estimated_delivery_date || "");
      fd.append("estimated_delivery_days", addFormData.estimated_delivery_days || "");
      fd.append("ships_from", addFormData.ships_from || "");
      fd.append("eligible_for", addFormData.eligible_for || "");
      fd.append("details", addFormData.details || "");
      fd.append("lang", selectedLanguage);

      try {
        const response = await fetch(`${API_BASE_URL}products`, {
          method: "POST",
          body: fd,
          headers: {
            Authorization: `Bearer ${user.authorisation.token}`,
          },
        });
        const responseData = await response.json();
        if (responseData.res === true) {
          setSignupStatus(responseData.msg);
          NotificationManager.success(responseData.msg);
          setAddBtnDis(false);
          navigate("/products");
        } else {
          // Authentication failed, display an error message
          setSignupStatus(responseData.msg);
          NotificationManager.warning(responseData.msg);
          setAddBtnDis(false);
        }
      } catch (error) {
        console.error("Error during Sign UP:", error);
        setAddBtnDis(false);
      }
    }
  };

  useEffect(() => {
    // alert(id);
    fetchProductDetails();
    fetchSubCategory();
    fetchShowSubCategory();
    fetchStoreData();
  }, []);

  return (
    <div>
      <div className="dashHeader">
        <VendorHeader />
      </div>
      <div className="adminDash">
        <Sidebar />
        <div className="rightSide">
          <h2>{langJson?.duplicateproduct}</h2>
          <ul className="addAddress">
            <li>
              <label>{langJson?.articleno}.</label>
              <input type="text" name="article_no" onChange={handleChange} value={addFormData.article_no} />
            </li>
            <li>
              <label>{langJson?.orderno}.</label>
              <input type="text" name="order_no" onChange={handleChange} value={addFormData.order_no} />
            </li>
            <li>
              <label>{langJson?.name}</label>
              <input type="text" name="article_name" onChange={handleChange} value={addFormData.article_name} />
            </li>
            <li>
              <label>{langJson?.brand}</label>
              <input type="text" name="brand" onChange={handleChange} value={addFormData.brand} />
            </li>
            <li>
              <label>{langJson?.colour}</label>
              <input type="text" name="color" onChange={handleChange} value={addFormData.color} />
            </li>
            <li>
              <label>{langJson?.currency}</label>
              <select name="currency" onChange={handleChange} value={addFormData.currency}>
                {currency?.map((item, index) => (
                  <option key={index} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </li>
            <li className="fullWidth">
              <label>{langJson?.articledescription}</label>
              <textarea name="article_description" value={addFormData.article_description} onChange={handleChange}></textarea>
            </li>

            {sizeError ? <span className="lgnStatus">{sizeError}</span> : null}

            <li className="sizeInput">
              <label>{langJson?.size}:</label>

              <input type="text" name="size" value={addFormData.size} onChange={handleChange} />
              <button type="button" className="addBtn" onClick={() => addSize()}>
                {langJson?.add}
              </button>
              <span onClick={() => setAddFormData((prev) => ({ ...prev, article_type: "public" }))}>
                <input type="radio" name="articleType" checked={addFormData.article_type === "public" ? true : false} />
                {langJson?.public}
              </span>
              <span onClick={() => setAddFormData((prev) => ({ ...prev, article_type: "hidden" }))}>
                <input type="radio" name="articleType" checked={addFormData.article_type === "hidden" ? true : false} />
                {langJson?.hidden}
              </span>
              {sizeArray?.map((item, index) => (
                <div className="sizeLoop" key={index}>
                  <div className="quan">
                    {item?.size} <img className="delIcon" src={deleteIcon} alt="" onClick={() => removeSize(index)} />
                  </div>
                  <input type="text" value={item?.quantity} onChange={(e) => onQuantityChange(e, index)} />
                </div>
              ))}
            </li>
            <li>
              <label>{langJson?.price}:</label>
              <input type="number" name="price" onChange={handleChange} value={addFormData.price} />
            </li>
            <li>
              <label>{langJson?.unitprice}:</label>
              <input type="number" name="unit_price" onChange={handleChange} value={addFormData.unit_price} />
            </li>

            <li>
              <label>{langJson?.originalprice}:</label>
              <input type="number" name="original_price" onChange={handleChange} value={addFormData.original_price} />
            </li>
            <li>
              <label>{langJson?.maincategorygroupseasonarticle}:</label>
              <input type="text" name="main_category" onChange={handleChange} value={addFormData.main_category} />
            </li>
            <li>
              <label>{langJson?.subcategory}:</label>
              <select name="sub_category" onChange={handleChange} value={addFormData.sub_category}>
                <option value={null}>{langJson?.subcategory}</option>
                {subCategoryList?.map((item, index) => (
                  <option key={index} value={item?.id}>
                    {item?.title}
                  </option>
                ))}
              </select>
            </li>
            <li>
              <label>{langJson?.showcategory}:</label>
              <select name="show_category" onChange={handleChange} value={addFormData.show_category}>
                <option value={null}>{langJson?.showcategory}</option>
                {showCategoryList?.map((item, index) => (
                  <optgroup label={item?.title} key={index}>
                    {item?.sub_categories?.map((chItem, chIndex) => (
                      <option key={chIndex} value={chItem?.id}>
                        {chItem?.title}
                      </option>
                    ))}
                  </optgroup>
                ))}
              </select>
            </li>
            <li>
              <label>{langJson?.madein || "Made In"}:</label>
              {renderMadeInDropdown()}
            </li>

            <li>
              <label>{langJson?.stocktype || "Stock Type"}:</label>
              <select name="stock_type" onChange={handleChange} value={addFormData.stock_type} style={{ width: "100%", padding: "8px" }}>
                <option value="in_stock">{langJson?.instock || "In Stock"}</option>
                <option value="order">{langJson?.order || "Order"}</option>
              </select>
            </li>

            {addFormData.stock_type === "in_stock" && (
              <li>
                <label>{langJson?.estimateddeliverydays || "Estimated Delivery Days"}:</label>
                <input type="number" name="estimated_delivery_days" onChange={handleChange} value={addFormData.estimated_delivery_days} min="1" max="365" style={{ width: "100%", padding: "8px" }} />
              </li>
            )}

            {addFormData.stock_type === "order" && (
              <li>
                <label>{langJson?.estimateddeliverydate || "Estimated Delivery Date"}:</label>
                <input type="date" name="estimated_delivery_date" onChange={handleChange} value={addFormData.estimated_delivery_date} style={{ width: "100%", padding: "8px" }} />
              </li>
            )}

            <li>
              <label>{langJson?.shipsfrom || "Ships From"}:</label>
              {renderShipsFromDropdown()}
            </li>

            <li>
              <label>{langJson?.eligiblefor || "Eligible For"}:</label>
              <input type="text" name="eligible_for" onChange={handleChange} value={addFormData.eligible_for} style={{ width: "100%", padding: "8px" }} />
            </li>

            <li className="fullWidth">
              <label>{langJson?.details || "Details"}:</label>
              <textarea name="details" onChange={handleChange} value={addFormData.details} rows="3" style={{ width: "100%", padding: "8px" }} />
            </li>

            <li className="fullWidth">
              <label>{langJson?.uploadimages}:</label>
              <span className="lgnStatus">{imageError}</span>
              <br></br>
              <input type="file" ref={imageBtnRef} hidden onChange={(e) => onImageMutipleUpload(e)} multiple />
              <button onClick={() => imageBtnRef.current.click()}>{langJson?.chooseimages}</button>
              <div className="uploadFle" onDragOver={(e) => e.preventDefault()} onDrop={handleFrontImageDrop}>
                {existingImages?.length === 0 && newImages?.length === 0 ? <span className="uploadFleHint">{langJson?.dragdropimages ?? "Drag & drop images"}</span> : null}
                {existingImages?.map((item, index) => {
                  return (
                    <div className="uploadThumbItem" key={`existing-${item?.id || index}`}>
                      <img className="uploadThumbImg" src={IMAGE_URL + item.image} alt="" />
                      <img className="uploadThumbDelete" src={deleteIcon} alt="" onClick={() => handleRemoveImageFromServer(index)} />
                    </div>
                  );
                })}
                {newImages?.map((item, index) => {
                  return (
                    <div className="uploadThumbItem" key={`new-${index}`}>
                      <img className="uploadThumbImg" src={URL.createObjectURL(item)} alt="" />
                      <img className="uploadThumbDelete" src={deleteIcon} alt="" onClick={() => handleRemoveImage(index)} />
                    </div>
                  );
                })}
              </div>
              {/* {images?.map((item, index) => {
                return (
                  <>
                    <img key={index} className="productImgClass" src={URL.createObjectURL(item)} />
                    {allDetails?.images?.some(chItem => chItem.image === imagesPath[index].image) ? (
                      <img key={index} src={deleteIcon} alt="" onClick={() => handleRemoveImageFromServer(index)} />
                    ) : (
                      <img key={index} src={deleteIcon} alt="" onClick={() => handleRemoveImage(index)} />
                    )}
                  </>
                );
              })} */}
            </li>
            <li className="fullWidth">
              {storeData && storeData?.active_plan !== 4 && (
                <div style={{
                  padding: "12px 16px",
                  marginBottom: "16px",
                  background: "#000",
                  border: "1px solid #333",
                  borderRadius: "4px",
                  color: "#ecf0f1",
                  fontSize: "14px",
                }}>
                  {langJson?.ai_enhancer_pro_ai_only || "AI Enhancer is available only with Pro AI plan. Upgrade to unlock this feature."}
                </div>
              )}
              <div style={{ opacity: storeData?.active_plan === 4 ? 1 : 0.5, pointerEvents: storeData?.active_plan === 4 ? 'auto' : 'none' }}>
                <AiEnhancePanel
                  images={newImages}
                  onReplaceImage={handleReplaceNewImage}
                  onAddImage={(f) => setNewImages((prev) => [...prev, f])}
                  existingImages={existingImages}
                  apiBaseUrl={API_BASE_URL}
                  token={user?.authorisation?.token}
                  langJson={langJson}
                />
              </div>
            </li>

            <li className="fullWidth">
              <label>{langJson?.uploadvideos || "Upload Videos"}:</label>
              {videoError && <span className="lgnStatus">{videoError}</span>}
              <br />
              <input
                type="file" ref={videoBtnRef} hidden
                onChange={handleVideoInput} multiple
                accept=".mp4,.webm,.mov,.avi,.mkv"
              />
              <button type="button" onClick={() => videoBtnRef.current.click()}>
                {langJson?.uploadvideo || "Choose video"}
              </button>
              <div
                className="uploadFle"
                onDragOver={(e) => e.preventDefault()}
                onDrop={handleVideoDrop}
              >
                {existingVideos.length === 0 && videos.length === 0 && (
                  <span className="uploadFleHint">{langJson?.dragdropvideo || "Drag & drop video files"}</span>
                )}
                {existingVideos.map((item, index) => (
                  <div className="uploadThumbItem" key={`existing-${item?.id || index}`}>
                    <div className="uploadVideoThumb">
                      <span>📹</span>
                      <p>{item.video?.substring(0, 20)}</p>
                    </div>
                    <img className="uploadThumbDelete" src={deleteIcon} alt="remove" onClick={() => handleRemoveExistingVideo(index)} />
                  </div>
                ))}
                {videos.map((item, index) => (
                  <div className="uploadThumbItem" key={`new-${index}`}>
                    <div className="uploadVideoThumb">
                      <span>📹</span>
                      <p>{item.name.substring(0, 20)}</p>
                    </div>
                    <img className="uploadThumbDelete" src={deleteIcon} alt="remove" onClick={() => handleRemoveVideo(index)} />
                  </div>
                ))}
              </div>
            </li>

            <li className="fullWidth saveBtn">
              <button type="button" disabled={addBtnDis} onClick={() => onDuplicateArticle()}>
                {addBtnDis ? langJson?.pleasewait : langJson?.savechanges}
              </button>
            </li>
            <span className="lgnStatus">{signupStatus}</span>
          </ul>
        </div>
      </div >
      <VendorFooter />
    </div >
  );
};
export default DuplicateProduct;
